"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_FILTERS = exports.DerivedStatusBadge = exports.STATUS_LABELS = exports.STATUS_TONES = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Lang_js_1 = require("../Lang.js");
/**
 * The admin's names for the derived subscription statuses.
 *
 * The codes come from TwiSubscriptionStatus::derive() on the server; this file only decides what
 * customer service reads. The member-facing page has its own, deliberately shorter vocabulary —
 * the two are allowed to differ in wording, never in which state they are describing.
 *
 * Every terminal state has its own name here, because "Canceled with a date in the past" was being
 * shown for a comp that ran its course, a subscription ended by staff, and a member who never
 * entered a card at all.
 */
exports.STATUS_TONES = {
    active: 'good',
    complimentary: 'good',
    extended: 'good',
    cancelling: 'warn',
    past_due_grace: 'warn',
    past_due: 'warn',
    incomplete: 'neutral',
    abandoned: 'neutral',
    comp_expired: 'neutral',
    lapsed: 'danger',
    canceled: 'danger',
    ended_no_date: 'danger',
    unknown: 'neutral',
};
exports.STATUS_LABELS = {
    active: 'Active',
    complimentary: 'Comped',
    extended: 'Extended',
    cancelling: 'Active — ending',
    past_due_grace: 'Past due — in grace',
    past_due: 'Past due',
    incomplete: 'Incomplete',
    abandoned: 'Abandoned checkout',
    comp_expired: 'Comp ended',
    lapsed: 'Lapsed — payment failed',
    canceled: 'Canceled',
    ended_no_date: 'Ended — no end date recorded',
    unknown: 'Unknown',
};
var TONE_COLOURS = {
    good: { color: '#1a6e1e', bg: 'rgba(25,148,32,0.10)' },
    warn: { color: '#92400e', bg: 'rgba(245,158,11,0.14)' },
    danger: { color: '#9e3a3a', bg: 'rgba(211,47,47,0.09)' },
    neutral: { color: '#555', bg: 'rgba(0,0,0,0.06)' },
};
/**
 * @param status the derived code
 * @param through the date the status runs to, already formatted by the server
 */
var DerivedStatusBadge = function (_a) {
    var _b, _c;
    var status = _a.status, through = _a.through;
    var tone = TONE_COLOURS[(_b = exports.STATUS_TONES[status]) !== null && _b !== void 0 ? _b : 'neutral'];
    var label = (_c = exports.STATUS_LABELS[status]) !== null && _c !== void 0 ? _c : status;
    return (react_1.default.createElement(Box_1.default, { "data-status": status, sx: { display: 'inline-flex', flexDirection: 'column', gap: '2px' } },
        react_1.default.createElement(Box_1.default, { sx: {
                display: 'inline-flex', alignItems: 'center', gap: '5px',
                px: '10px', py: '3px', borderRadius: '12px',
                backgroundColor: tone.bg, color: tone.color,
                fontSize: '12px', fontWeight: 700, whiteSpace: 'nowrap',
            } },
            react_1.default.createElement(Box_1.default, { sx: { width: '6px', height: '6px', borderRadius: '50%', backgroundColor: tone.color, flexShrink: 0 } }),
            (0, Lang_js_1.__)(label)),
        through && (react_1.default.createElement(Box_1.default, { sx: { fontSize: '11px', color: '#888', pl: '4px', whiteSpace: 'nowrap' } }, through))));
};
exports.DerivedStatusBadge = DerivedStatusBadge;
/** The filter chips, in the order customer service works through them. */
exports.STATUS_FILTERS = [
    { value: 'all', label: 'All' },
    { value: 'active', label: 'Active' },
    { value: 'complimentary', label: 'Comped' },
    { value: 'cancelling', label: 'Ending' },
    { value: 'past_due', label: 'Past due' },
    { value: 'ended', label: 'Ended' },
    { value: 'incomplete', label: 'Incomplete' },
];
